import { Box } from "@mui/material";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";
import { setDocumentTitle } from "~/lib/commonUtils";
import { useSecurityPipelineIntegrations } from "~/pages/integrations/security-pipeline/hooks/useSecurityPipelineIntegrations";
import { LoadingPage } from "~/components/loading";
import { SecurityPipelineGithubPageHeader } from "../components/SecurityPipelineGithubPageHeader/SecurityPipelineGithubPageHeader";
import { SecurityPipelineGithubPageTabs } from "./components/SecurityPipelineGithubPageTabs/SecurityPipelineGithubPageTabs";
import { SECURITY_PIPELINE_DISPLAY_NAME } from "../../constants";

export interface SecurityPipelineGithubSpacePageProps {
  scope: SpaceScope | OrganizationScope;
}

export const SecurityPipelineGithubSpacePage = ({
  scope,
}: SecurityPipelineGithubSpacePageProps) => {
  const { integration, isLoading } = useSecurityPipelineIntegrations();
  const integrationId = integration?.mrn.split("/").pop();

  setDocumentTitle([
    integration?.name,
    `Github ${SECURITY_PIPELINE_DISPLAY_NAME}`,
    "Integrations",
    scope.name,
  ]);

  if (isLoading) {
    return <LoadingPage what="Security Pipeline" />;
  }

  return (
    <Box>
      <SecurityPipelineGithubPageHeader
        integrationId={integrationId}
        integrationStatus={integration?.status}
        scope={scope}
        errorMsg={null}
        integrationName="Security Pipeline"
        lastUpdated={integration?.lastModified}
      />
      <SecurityPipelineGithubPageTabs scope={scope} />
    </Box>
  );
};
